import React from "react";
import db from "./database.json"

var database = db.shopifyData ;


function Table1() {
  return (
    <table cellPadding="30px" id="dataBase">
      <thead>
        <tr height="40px" className="tableHeader">
          <th>Rank</th>
          <th>Store</th>
          <th>Yearly Revenue</th>
          <th>Country/Region</th>
          <th>Monthly Traffic</th>
        </tr>
      </thead>
      <tbody>
        <tr
          className="dataRow odd"
          height="31"
          role="button"
          title="Check the BBC Shop US store"
        >
          <td>1</td>
          <td className="Store">
            <a target="_blank" href="https://shop.bbc.com/">
              BBC Shop US
            </a>
          </td>
          <td>-</td>
          <td className="location">United States</td>
          <td>416,700,000</td>
        </tr>
        <tr
          className="dataRow even"
          height="31"
          role="button"
          title="Check the Gymshark ROW store"
        >
          <td>2</td>
          <td className="Store">
            <a target="_blank" href="https://row.gymshark.com/">
              Gymshark ROW
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            United Kingdom
          </td>
          <td className="xl88" width="64">
            22,800,000
          </td>
        </tr>
        <tr
          className="dataRow odd"
          height="31"
          role="button"
          title="Check the Gymshark UK store"
        >
          <td>3</td>
          <td className="Store">
            <a target="_blank" href="https://uk.gymshark.com/">
              Gymshark UK
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            United Kingdom
          </td>
          <td className="xl88" width="64">
            22,800,000
          </td>
        </tr>
        <tr
          className="dataRow even"
          height="31"
          role="button"
          title="Check the Gymshark US store"
        >
          <td>4</td>
          <td className="Store">
            <a target="_blank" href="https://row.gymshark.com/">
              Gymshark US
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            United States
          </td>
          <td className="xl88" width="64">
            22,800,000
          </td>
        </tr>
        <tr
          className="dataRow odd"
          height="20"
          role="button"
          title="Check the JB Hi-Fi store"
        >
          <td height="20" className="xl84" width="64">
            5
          </td>
          <td className="Store">
            <a target="_blank" href="https://www.jbhifi.com.au/">
              JB Hi-Fi
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            Australia
          </td>
          <td className="xl88" width="64">
            13,500,000
          </td>
        </tr>
        <tr
          className="dataRow even"
          height="31"
          role="button"
          title="Check the Cettire store"
        >
          <td>6</td>
          <td className="Store">
            <a target="_blank" href="https://www.cettire.com/">
              Cettire
            </a>
          </td>
          <td>-</td>
          <td className="location">United States</td>
          <td>24,400,000</td>
        </tr>
        <tr
          className="dataRow odd"
          height="31"
          role="button"
          title="Check the ColourPop store"
        >
          <td>7</td>
          <td className="Store">
            <a target="_blank" href="https://colourpop.com/">
              ColourPop
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            United States
          </td>
          <td className="xl88" width="64">
            4,280,000
          </td>
        </tr>
        <tr
          className="dataRow even"
          height="31"
          role="button"
          title="Check the Puravida store"
        >
          <td>8</td>
          <td className="Store">
            <a target="_blank" href="https://www.puravidabracelets.com/">
              Pura Vida Bracelets
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            United States
          </td>
          <td className="xl88" width="64">
            17,600,000
          </td>
        </tr>
        <tr
          className="dataRow odd"
          height="31"
          role="button"
          title="Check the Beeinspired store"
        >
          <td>9</td>
          <td className="Store">
            <a target="_blank" href="https://www.beeinspiredclothing.com/">
              Bee Inspired Clothing
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            United Kingdom
          </td>
          <td className="xl88" width="64">
            14,500,000
          </td>
        </tr>
        <tr
          className="dataRow even"
          height="20"
          role="button"
          title="Check the Staples store"
        >
          <td height="20" className="xl84" width="64">
            10
          </td>
          <td className="Store">
            <a target="_blank" href="https://www.staples.ca/">
              Staples
            </a>
          </td>
          <td className="xl87" width="232">
            -
          </td>
          <td className="location" width="64">
            Canada
          </td>
          <td className="xl88" width="64">
            7,460,000
          </td>
        </tr>
      </tbody>
    </table>
  );
}
function getDatabase() {
    var mdb = database.map((item, i) => (
        <tr className={i % 2 == 0 ? 'even':'odd'}>
            <td className="firsttCol">{item[0]}</td>
            <td>{item[1]}</td>
            <td ><a target="_blank"  href={'https://' + item[2]}>{item[2]}</a></td>
            
            <td className="thirdLastCol">{item[3]}</td>
            <td className="secondLastCol">{"$"+item[4]}</td>
            <td className="lastCol">{item[5]}</td>
        </tr>
     ));
    mdb.unshift(<tr height="40px" className="tableHeader">
        <th>Rank</th>
        <th>Alexa Rank</th>
        <th>Domain</th>
        <th className="thirdLastCol">Monthly Traffic</th>
        <th className="secondLastCol" >Monthly Revenue (USD)</th>
        <th className="lastCol">Country</th>
    </tr>)
    return mdb
}
function getStoreList() {
    return ['','colourpop.com',
    'jeffreestarcosmetics.com',
    'fashionnova.com',
    'reddressboutique.com',
    'gymshark.com',
    'cupshe.com',
    'omaze.com',
    'mnml.la',
    'yeezysupply.com',
    'kith.com',
    'fangamer.com',
    'allbirds.com',
    'bulletproof.com',
   ' gfuel.com',
    'decathlon.com',
    'cettire.com',
    'untilgone.com',
    'inspireuplift.com',
    'citiesocial.com',
    'loreta.com.au',
    'stevemadden.com',
    'spigen.com',
    'beeinspiredclothing.com',
    'fleshlight.com',
    'usatuan.com',
    'misthub.com',
    'eightvape.com',
    'ripndipclothing.com',
    'bohme.com',
    'creativebooster.net',
    'bungiestore.com',
    'peakdesign.com',
    'kbdfans.cn',
    'sokoglam.com',
    'huel.com',
    'bajaao.com',
    'theyetee.com',
    'mavi.com',
    'gouletpens.com',
    'culturekings.com.au',
    'bettersnatch.com',
    'williampainter.com',
    'quickmobilefix.com',
    'ridgewallet.com',
    'y8.com',
    'outdoorvoices.com',
    'chubbiesshorts.com',
    'bombas.com',
    'shopmrbeast.com',
    'islamicity.org',
   'kyliecosmetics.com',
   'secretlab.co',
    'teefury.com',
    'manscaped.com',
    'halobeauty.com',
    'popsockets.com',
    'bdgastore.com',
    'vicicollection.com',
    'alrugaibfurniture.com',
    'morphebrushes.com',
    'puravidabracelets.com',
    'deadstock.ca',
    'blacktailor.store',
    'wearfigs.com',
    'aloyoga.com',
    'thepihut.com',
    'headphonezone.in',
    'fanjoy.co',
    'soylent.com',
    'havenshop.com',
    'fab.com',
    'timbuk2.com',
    'mediamarkt.pt',
    'victoryhangers.com',
    'brooklinen.com',
    'behearty.com',
    'sisterjane.com',
    'heatonist.com',
    'unique - vintage.com',
    'untuckit.com',
    'lackofcolor.com.au',
    'crownandcaliber.com',
    'kingice.com',
    'mirascreen.com',
    'shethinx.com',
    'naturalbabyshower.co.uk',
    'ruggable.com',
   'dailysteals.com',
    'mous.co',
    'zoofashions.com',
    'limitedrungames.com',
    'teddyfresh.com',
    'indestructibleshoes.com',
    'livefitapparel.com',
    'racedayquads.com',
    'thebrick.com',
    'onewheel.com',
    'mondotees.com',
    'hanon - shop.com',
    'pimaxvr.com']
}
function getLocations() {
  return [
      'US',
'US',
'US',
'US',
'UK',
'US',
'US',
 ' -',
 'UK',
'US',
'US',
'US',
'US',
'US',
'FR',
'AU',
 '-',
 'US',
'TW',
 ' -',
 'US',
'US',
'GB',
'US',
'US',
'US',
'US',
'US',
'US',
'PA',
'US',
'US',
' -',
'US',
'PA',
'US',
'US',
'US',
'CA',
'AU',
'US',
'US',
'GB',
'US',
 '-',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'US',
'IN',
'US',
'US',
'CA',
 '-',
 'US',
'US',
'GB',
'IN',
'US',
'FR',
'CA',
'IE',
'US',
 '-',
 'US',
'US',
'US',
'JP',
'US',
'US',
'US',
'JP',
'US',
'US',
'PA',
'US',
'GB',
'US',
'US',
'FR',
'GB',
'US',
'US',
'US',
'US',
'CA',
'CA',
'CA',
'US',
 '-',
 '-'

  ];
}
export { Table1, getDatabase, getStoreList, getLocations };
